import registrationStep from "../../../registrationStep";
import MinorList from "./MinorList";

export default registrationStep(MinorList, "minors");



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorList/index.js